import * as React from 'react';
import { ValidationSummary } from 'ui';
import styles from './flex-panel.scss';

export class FlexPanel extends React.PureComponent<any, any> {

    public render() {
       const {
          componentId ,
          validation
        } = this.props;

        return (
          <div className={`${styles.flexPanel} ${this.props.className}`} id={ componentId }>
            <ValidationSummary validationError={validation}/>
            <div className="main-grid">
              <div className="row justify-content-between">
                {this.props.children}
              </div>
            </div>
          </div>
        );
      }
    }
